import Vue from 'vue'
import App from './App.vue'
import router from "./router/index"

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import './assets/css/common.css'
Vue.config.productionTip = false

// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 将富文本编辑器，注册为全局可用的组件
Vue.use(VueQuillEditor)

import axios from 'axios'
// 配置请求的跟路径
// axios.defaults.baseURL = 'http://127.0.0.1:8088/sysapi/'
// axios.defaults.baseURL = 'http://47.108.216.158:8088/sysapi/'
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.interceptors.request.use(config => {
    config.headers.Authorization = window.sessionStorage.getItem('token')
    return config
})
axios.interceptors.response.use(response => {
    return response
})
Vue.prototype.$http = axios

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
